<template>
    <div class="page-header page-header-light">
        <div class="page-header-content header-elements-md-inline">
            <div class='page-title d-flex'>
                <tb-skeleton v-if="loading" :height="29" :width="250" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>
                <h4 v-else>
                    <span class='font-weight-semibold'>{{ showTitle }}</span><span v-if="showTitleSub"> - {{ showTitleSub }}</span><span v-if="showTitleId>0"> #{{ showTitleId }}</span>
                </h4>
            </div>
            <div v-if="!loading && showButtons.length>0" class="header-elements d-none">
                <div class="d-flex justify-content-center">
                    <a v-for="(button, b_index) in showButtons" :key="b_index" :href="button.url" class="btn btn-link btn-float text-body"><i v-bind:class="button.icon"></i> <span>{{ button.text }}</span></a>
                </div>
            </div>
            <div v-else-if="!loading"  class="header-elements d-none">
                <div class="d-flex justify-content-center">
                    <slot name="header-elements"></slot>
                </div>
            </div>
        </div>
        <div v-if="breadcrumbs.length>0" class="breadcrumb-line breadcrumb-line-light header-elements-md-inline">
            <div v-if="loading" style="padding: 10px 0;">
                <tb-skeleton :height="20" :width="200" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>
            </div>
            <div v-else class="d-flex">
                <a class="breadcrumb-item" href="/"><i class="icon-home2 position-left"></i> Home</a>
                <a v-for="(item, i_index) in showBreadcrums" :key="i_index" :href="item.url" class="breadcrumb-item" v-bind:class="{ 'active':i_index === Object.keys(showBreadcrums).length - 1 }">{{ item.text }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { TbSkeleton } from 'tb-skeleton';
import 'tb-skeleton/dist/skeleton.css';

export default {
    name: 'LimitlessPageHeader',
    components: {
        'tb-skeleton': TbSkeleton,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        subTitle: {
            type: String,
            default: '',
        },
        titleId: {
            type: [String, Number],
            default: 0,
        },
        breadcrumbs: {
            type: Array,
            default() {
                return [];
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
        buttons: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    computed: {
        showTitle() {
            return this.title;
        },
        showTitleSub() {
            return this.subTitle;
        },
        showTitleId() {
            return this.titleId;
        },
        showButtons() {
            return this.buttons;
        },
        showBreadcrums() {
            return this.breadcrumbs;
        },
    },
};
</script>
